import Content from "uxp-documentation/src/pages/uxp-api/reference-css/Selectors/Type selector";
import * as React from 'react';
export default {
  Content,
  React
};